import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { MirrorsListItem } from '@modules/mirrors-list/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  MIRRORS_LIST_API_URL,
  MIRRORS_LIST_PERMISSIONS,
  MIRRORS_LIST_QUERY_KEY,
} from '@modules/mirrors-list/constants';
import { keepPreviousData } from '@tanstack/vue-query';

export default function useMirrorsListQuery(
  tableState: Ref<ITableState>,
  mirrorNamespaceValue: Ref<string>,
): IContextQueryResult<
    ITableDataResponse<MirrorsListItem>,
    Error
  > {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<MirrorsListItem>>({
    queryKey: [MIRRORS_LIST_QUERY_KEY, tableState, mirrorNamespaceValue],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<MirrorsListItem>>(
      MIRRORS_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: MIRRORS_LIST_PERMISSIONS.SHOW,
        urlParams: {
          mirrorsNamespace: mirrorNamespaceValue.value,
        },
      },
    ),
    placeholderData: keepPreviousData,
  });
}
